import { createApp } from 'vue'
import '@css/website.css'

import App from '@website/views/Login.vue'

const app = createApp(App)

app.mount('#app')
